import clsx from 'clsx';
import { getScrollBehavior } from 'core/utils/motion';
import { guidLibGenerator } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { withTranslation } from 'react-i18next';
import AccordionList2Item from './AccordionList2Item';

const AccordionList2 = ({
  arrowView = 'right',
  tabs = [],
  onGetLessonItemMessages,
  onChangeOpenedTabs = () => null,
  shouldScrollIntoViewOnExpand = false,
  style,
}) => {
  const instanceId = useRef(guidLibGenerator()).current;
  const accordionRefs = useRef([]);

  async function onChangeAccordion(item, expanded) {
    if (onGetLessonItemMessages && expanded && item?.assignment?.guid) {
      await onGetLessonItemMessages(item.assignment);
    }

    onChangeOpenedTabs(item.id, expanded);
  }

  // Once the expand transition finishes the layout has its final height, so the submodules
  // hidden below the fold are scrolled into view. Fires only on expand (onEntered), never on
  // collapse, and not for defaultExpanded panels on mount (MUI skips the transition there).
  function onAccordionEntered(index) {
    accordionRefs.current[index]?.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
  }

  function setAccordionRef(index, element) {
    accordionRefs.current[index] = element;
  }

  return (
    <div className={clsx('accordion-list2', `accordion-list2--arrow-${arrowView}`, { 'accordion-list2--simple': style === 'simple' })}>
      {tabs.map((item, i) => (
        <AccordionList2Item
          key={i}
          contentId={`${instanceId}-panel-${i}-content`}
          headerId={`${instanceId}-panel-${i}-header`}
          index={i}
          item={item}
          onChange={onChangeAccordion}
          onEntered={onAccordionEntered}
          setAccordionRef={setAccordionRef}
          shouldScrollIntoViewOnExpand={shouldScrollIntoViewOnExpand}
        />
      ))}
    </div>
  );
};

AccordionList2.propTypes = {
  arrowView: PropTypes.string,
  onChangeOpenedTabs: PropTypes.func,
  onGetLessonItemMessages: PropTypes.func,
  shouldScrollIntoViewOnExpand: PropTypes.bool,
  style: PropTypes.string, //'default' | 'simple'
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      assignment: PropTypes.shape({ guid: PropTypes.string }),
      children: PropTypes.node,
      className: PropTypes.string,
      defaultExpanded: PropTypes.bool,
      disabled: PropTypes.bool,
      expanded: PropTypes.bool,
      id: PropTypes.string,
      // Cabecera sin contenido visible ni chevron, fuera del Tab y del árbol accesible; exige `expanded: true`
      isHeaderDecorative: PropTypes.bool,
      // La cabecera contiene otros controles: el conmutador es AccordionHeaderToggle y el título lleva useAccordionItemLabelId() o AccordionItemLabel
      hasInnerToggle: PropTypes.bool,
      title: PropTypes.node,
    })
  ).isRequired,
};

export default withTranslation('course')(AccordionList2);
